// src/util/hooks/useAutoLogout.js
import { useEffect, useRef } from "react";

export default function useAutoLogout(onLogout, timeout = 10 * 60 * 1000) {
    const timerRef = useRef(null);

    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => onLogout && onLogout('inactivity'), timeout);
    };

    useEffect(() => {
        const events = ["mousemove", "keydown", "click", "scroll"];

        events.forEach(event => window.addEventListener(event, resetTimer));

        resetTimer(); // iniciar temporizador

        return () => {
            events.forEach(event => window.removeEventListener(event, resetTimer));
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [onLogout, timeout]);
}
